jQuery(function ($) {
	function productVariationInit() {
        // Woocommerce variation js
        $('form.cart input[type="radio"] + label').click(function () {
            $(this).prev().prop('checked', true);
            $(this).parents('form.cart').find('input[type="radio"] + label.current').removeClass('current');
            //$(this).parent('td').find('select').find('option[value=' + $(this).prev().val() + ']').attr('selected', 'selected').trigger('change');
            $(this).parent('td').find('select').val( $(this).prev().val() ).trigger('change');
            $(this).addClass('current');
        });

        // if select is used remove current from visible variations.
        $('form.cart td.value select').change(function () {
            let parent = $(this).parents('td.value');
            parent.find('input[type="radio"]').next().removeClass('current');
            setTimeout(function () {
                // activate when using select
                calculateHidden(parent);
            },1);
        });

        // activate on load.
        calculateHiddenAll();
        // activate on grid / list toggle
        $('.gridlist-toggle a').click(function () {
            $('form.cart td.value select').addClass('hidden');
            calculateHiddenAll();
        });

        // add pretty select
        //$('li.product form.cart td.value #izmeri').select2();

        // Calculate which elements to hide from select.
        function calculateHidden(elem) {
            elem.css('max-width', '350px'); //reset

            let boxWidth = elem.width();
            let boxHeight = elem.height();

            elem.find('option').removeClass('overflowed');
            elem.find('label').removeClass('overflown-label');

            elem.find('input[type="radio"] + label').each(function () {
                let elemPos = $(this).position();

                if ( elemPos.top + 1 >= boxHeight || elemPos.left + 1 >= boxWidth ) {
                    let hiddenVal = $(this).prev().val();
                    $(this).parents('td.value').find('option[value="' + hiddenVal + '"]').addClass('overflowed');
                    $(this).addClass('overflown-label');
                }
            });

            // variation dropdown placement fix
            if ( $('body.post-type-archive-product').length > 0 ) {
                let lastLabelWidth = elem.find('label:not(.overflown-label)').last().outerWidth();
                let elemLeftPos = elem.find('label:not(.overflown-label)').last().position().left;
                let realWidth = Math.ceil(lastLabelWidth) + Math.ceil(elemLeftPos) + 20; // + 20 = elem padding and label margins
                elem.css('max-width', realWidth);
            }

            if ( elem.find('option.overflowed').length <= 0 ) {
                elem.find('select').addClass('empty');
            } else {
                elem.find('select').removeClass('empty');
                $('form.cart td.value select').removeClass('hidden');
            }
        }

        // Loop through all products
        function calculateHiddenAll() {
            setTimeout(function () {
                $('form.cart td.value').each(function () {
                    calculateHidden($(this));
                });
            }, 501);
        }

        function loadProductVariationAddToCartBlock() {
            const addToCartBlock = $('.variations_form.cart');

            addToCartBlock.each(function(){
                $(this).addClass('loaded');
            })
        }

        function init() {
            setTimeout(function(){
                loadProductVariationAddToCartBlock();
            }, 1000);

        }

        init();
	}

    productVariationInit();

    $( document ).on('vet-filters-ajax-complete', function() {
        productVariationInit();
    });
});

jQuery(document).ready(function ($) {
	$('form.cart td.value select').each(function () {
		$(this).select2({
			minimumResultsForSearch: -1,
			dropdownCssClass: 'variation-select2',
			templateResult: function (data, container) {
				if (data.element) {
					$(container).addClass($(data.element).attr('class'));
				}
				return data.text;
			}
		});
	});
});